import React from 'react';

import {
	MenuButtonAddTable,
	MenuButtonBlockquote,
	MenuButtonBold,
	MenuButtonBulletedList,
	MenuButtonEditLink,
	MenuButtonHorizontalRule,
	MenuButtonImageUpload,
	MenuButtonIndent,
	MenuButtonItalic,
	MenuButtonOrderedList,
	MenuButtonRedo,
	MenuButtonRemoveFormatting,
	MenuButtonStrikethrough,
	MenuButtonSubscript,
	MenuButtonSuperscript,
	MenuButtonUnderline,
	MenuButtonUndo,
	MenuButtonUnindent,
	MenuControlsContainer,
	MenuDivider,
	MenuSelectHeading,
	MenuSelectTextAlign,
	isTouchDevice,
	type ImageNodeAttributes,
} from 'mui-tiptap';

export interface EditorMenuControlsProps {
	onUploadFiles: (
		files: File[],
	) => ImageNodeAttributes[] | Promise<ImageNodeAttributes[]>;
}

export default function EditorMenuControls({
	onUploadFiles,
}: EditorMenuControlsProps) {
	return (
		<MenuControlsContainer>
			<MenuButtonUndo />
			<MenuButtonRedo />
			<MenuDivider />
			<MenuSelectHeading />
			<MenuDivider />
			<MenuButtonBold />
			<MenuButtonItalic />
			<MenuButtonUnderline />
			<MenuButtonStrikethrough />
			<MenuButtonSubscript />
			<MenuButtonSuperscript />
			<MenuDivider />
			<MenuButtonEditLink />
			<MenuButtonImageUpload onUploadFiles={onUploadFiles} />
			<MenuButtonHorizontalRule />
			<MenuDivider />
			<MenuSelectTextAlign />
			<MenuButtonBulletedList />
			<MenuButtonOrderedList />
			<MenuButtonBlockquote />
			<MenuButtonAddTable />
			{/* On touch devices, we'll show indent/unindent buttons, since they're
      unlikely to have a keyboard that will allow for using Tab/Shift+Tab. These
      buttons probably aren't necessary for keyboard users and would add extra
      clutter. */}
			{isTouchDevice() && (
				<>
					<MenuButtonIndent />
					<MenuButtonUnindent />
				</>
			)}
			<MenuButtonRemoveFormatting />
		</MenuControlsContainer>
	);
}
